(function () {
  'use strict';

  let angular = window.angular;

  PublicRouter.$inject = ['$stateProvider'];

  angular.module('app').config(PublicRouter);

  function PublicRouter($stateProvider, utils) {
    $stateProvider
      .state('member', {
        url: '/member?style&access_token&user_id&embedded',
        redirectTo: 'member.home',
        authenticated: true,
        component: 'memberComponent',
        params: {
          style: { type: 'string', inherit: true },
          access_token: { type: 'string', inherit: true },
          user_id: { type: 'string', inherit: true },
          embedded: { type: 'string', inherit: true },
        },
        resolve: {
          user: [
            'UserService',
            'RouterService',
            'AppUtils',
            '$rootScope',
            function (UserService, RouterService, utils, $root) {
              return UserService.getCurrent()
                .then((current) => {
                  RouterService.storeId(current.id, 'Principal');
                  return RouterService.getPrincipal(current);
                })
                .then((user) => {
                  $root.isAdmin = true;
                  $root.isSupportAdmin = true;
                  user.isAdmin = true;
                  user.isSupportAdmin = true;
                  user.image = UserService.getUserImageUrl(user);
                  $root.user = user;

                  if (user.mustChangePassword) {
                    const redirectError = new Error('Password change required');
                    redirectError.redirectTo = 'forcePasswordChange';
                    throw redirectError;
                  }

                  return user;
                })
                .catch((err) => {
                  if (err && err.redirectTo) {
                    throw err;
                  }
                  throw utils.getHTTPError(err, { redirectTo: 'public.login' });
                });
            },
          ],
          isAdmin: () => true,
          isSupportAdmin: () => true,
          vars: [
            'Var',
            function (Var) {
              return Var.find({ filter: { order: 'name ASC' } }).$promise.then((vars) => {
                return vars;
              });
            },
          ],
        },
        ncyBreadcrumb: {
          label: '<i class="fas fa-home"></i>',
        },
      })
      .state('forcePasswordChange', {
        url: '/password-change',
        authenticated: true,
        component: 'forcePasswordChangePage',
      })
      .state('member.home', {
        url: '/home',
        authenticated: true,
        component: 'memberHome',
        redirectTo: 'member.home.vars',
        resolve: {
          spammingSensorsData: [
            'Sensor',
            (Sensor) => Sensor.spamming().$promise
          ],
        },
        ncyBreadcrumb: {
          label: 'Home',
        },
      })
      .state('member.home.vars', {
        url: '/vars',
        authenticated: true,
        component: 'memberHomeVars',
        ncyBreadcrumb: {
          label: 'Resellers',
        },
      })
      .state('member.home.configs', {
        url: '/global-configs',
        component: 'globalConfigs',
        requireADLogin: true,
        authenticated: true,
        ncyBreadcrumb: {
          label: '{{"entities.organization.organizationConfig.modelNamePl" | translate}}',
        },
        resolve: {
          vars: [
            'Var',
            function (Var) {
              return Var.find({ filter: { order: 'name ASC' } }).$promise.then((vars) => {
                return vars;
              });
            },
          ],

          supportAdmins: [
            'SupportAdmin',
            function (SupportAdmin) {
              return SupportAdmin.find({
                filter: {
                  order: 'name ASC',
                  include: [
                    {
                      relation: 'vars',
                      scope: {
                        where: {
                          deleted: null,
                        },
                      },
                    },
                  ],
                },
              }).$promise;
            },
          ],
        },
      });
  }
})();
